const httpErrorCodes = {
  TOKEN_EXPIRED: 403,
  UNAUTHORIZED: 401,
  NOT_FOUND: 404,
  BAD_REQUEST: 400,
  API_CALL_LIMIT_EXCEEDED: 429,
  INTERNAL_SERVER_ERROR: 500,
};

export default httpErrorCodes;
